module.exports = __webpack_public_path__ + "static/img/abctest.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/abctest.jpg
// module id = 504
// module chunks = 0